import { Component, OnInit, ViewChild ,ViewChildren,QueryList} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import * as CommonConstants from '../../../utils/common.constants';
import { AddDepartmentComponent } from 'src/app/masters/add-department/add-department.component';
import { AddAddressComponent } from 'src/app/masters/add-address/add-address.component';
import { AddContactComponent } from 'src/app/masters/add-contact/add-contact.component';
import { AdministrationService } from '../administration.service';
import { LoaderService } from 'src/app/common/loader.service';
import swal from 'sweetalert2';
import {CountryISO } from 'ngx-intl-tel-input';
import { IntlTelNumberComponent } from 'src/app/common/intl-tel-number/intl-tel-number.component';
@Component({
  selector: 'app-add-administration',
  templateUrl: './add-administration.component.html',
  styleUrls: ['./add-administration.component.scss']
})
export class AddAdministrationComponent implements OnInit {

  administrationForm: FormGroup;
  organisms: any[];
  categories: any[];
  types: any[];
  legalForms: any[];
  qualityCertifications: any[];
  certifications: any[];
  categoriesType: any[];
  partnerGroup:any[];
  submitted = false;
  partnerId: number;
  partnerType: number = CommonConstants.PARTNER_ADMINISTRATION_TYPE;
  addAdministrationTitle=true;
  editAdministrationTitle;
  countries:any;
  CountryISO = CountryISO;
  @ViewChild(AddDepartmentComponent, { static: true }) hospDepartment: AddDepartmentComponent;
  @ViewChild(AddAddressComponent, { static: true }) hospAddress: AddAddressComponent;
  @ViewChild(AddContactComponent, { static: true }) hospContact: AddContactComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, private toasterService: ToastrService
    , private administrationService: AdministrationService, private loaderService: LoaderService) { }

  ngOnInit() {
    this.loadMasterData();
    this.getFromGroup();
  }

  loadMasterData() {
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getCategory().subscribe(response => {
      if (response && response['result']) {
        this.categories =response['result'].filter(category => category.partnerType == this.partnerType);
      }
    })
    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.types = response['result'].filter(type => type.partnerType == this.partnerType);
      }
    })
    this.masterService.getLegalForm().subscribe(response => {
      if (response && response['result']) {
        this.legalForms = response['result'];
      }
    })

    this.masterService.getCertification().subscribe(response => {
      if (response && response['result']) {
        this.certifications = response['result'];
      }
    })
    this.masterService.getAgmntQualtiy().subscribe(response => {
      if (response && response['result']) {
        this.qualityCertifications = response['result'];
      }
    })
    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.categoriesType  = response['result'];
      }
    })
    this.masterService.getGroup().subscribe(response => {
      if (response && response['result']) {
        this.partnerGroup = response['result'];
      }
    })
    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];

      }
    })
  }


  get f() { return this.administrationForm.controls; }

  /**
    * Declare form group
    *  
    */
  private getFromGroup() {
    this.administrationForm = this.formBuilder.group({
      'adminId': [],
      'pctypId': new FormControl(),
      'pagrpId': new FormControl(),
      'leforId': new FormControl(),
      'orgsmId': ['', Validators.required],
      'pacatId': new FormControl(), 
      'compaVaWorkFax': new FormControl(),
      'compaVaNameEn': ['', Validators.required],
      'compaVaWorkPhone': new FormControl(),
      'compaVaMobilePhone1': new FormControl(),
      'compaVaMobilePhone2': new FormControl(),
      'compaVaHomepage': new FormControl(),
      'compaVaEmail': ['', Validators.email],
      'compaNuNumberEmployees': new FormControl(),
      'certiId': new FormControl(),
      'agmntId': new FormControl(),
      'staRecCode': [true]
    })
  }

  save() {
    this.submitted = true;
    if (this.administrationForm.invalid) {
      return;
    }
    this.administrationForm.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
    let saveData = this.administrationForm.value;
    this.phoneNos.forEach(phone => {
      saveData[phone.type]=phone.setPhoneNumberfrmInternation();
    })

    this.loaderService.display(true);
    this.administrationService.save(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"] == 0) {
        this.administrationForm.patchValue({ adminId: response['result']['adminId'] });
        //this.toasterService.success(response['message'], 'Saved');
        swal.fire("Success", response['message'], 'success');
      } else {
        swal.fire("Error", response['message'], 'error');
        //this.toasterService.error(response['message'], 'Error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
reset() {
  this.administrationForm.reset();
}
onChangeOrganism(event){
  if(event && event.cotryId){
    let country  =this.countries.filter(type => type.cotryId == event.cotryId);
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=country[0].cotryCode;
   })
  }else{
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=CountryISO.France;
   })
  }
}
}
